import React, {useEffect, useState} from "react";

import {Modal, Checkbox, Button, Switch} from "antd";

import {COLORS} from "./PoolSupporter";
import {
    ModalTitle,
    ModalBodyWrapper,
    SwitchLabel,
    FilterModalContentWrapper,
    SearchInput,
    ListSection,
    ListHeader,
    ListTitle,
    ListItemLabel,
    NoResultSpan,
    FixedBottomBar,
    ButtonWrapper
} from "./PoolSupporter.styles";

const FilterModal = ({
    visible,
    onCancel,
    supporters,
    supportings,
    hiddenSupporters: parentHiddenSupporters,
    hiddenSupportings: parentHiddenSupportings,
    onSupportersChange,
    onSupportingsChange,
    showSelf: parentShowSelf,
    onShowSelfChange,
    showUnknown: parentShowUnknown,
    onShowUnknownChange,
    onSave
}) => {
    const [search, setSearch] = useState("");
    const [hiddenSupporters, setHiddenSupporters] = useState(parentHiddenSupporters);
    const [hiddenSupportings, setHiddenSupportings] = useState(parentHiddenSupportings);
    const [showSelf, setShowSelf] = useState(parentShowSelf);
    const [showUnknown, setShowUnknown] = useState(parentShowUnknown);

    useEffect(() => {
        setHiddenSupporters(parentHiddenSupporters);
    }, [parentHiddenSupporters]);
    useEffect(() => {
        setHiddenSupportings(parentHiddenSupportings);
    }, [parentHiddenSupportings]);

    const filteredSupporters = supporters.filter(s =>
        (s.supporterPool?.name || "-").toLowerCase().includes(search.toLowerCase())
    );
    const filteredSupportings = supportings.filter(s =>
        (s.pool?.name || "-").toLowerCase().includes(search.toLowerCase())
    );

    function handleSave() {
        onSupportersChange(hiddenSupporters);
        onSupportingsChange(hiddenSupportings);
        onShowSelfChange(showSelf);
        onShowUnknownChange(showUnknown);
        onCancel();

        if (onSave) {
            onSave();
        }
    }

    function handleReset() {
        setSearch("");
        setHiddenSupporters([]);
        setHiddenSupportings([]);
        setShowSelf(true);
        setShowUnknown(true);
    }

    return (
        <Modal
            title={<ModalTitle>Havuz Filtreleri</ModalTitle>}
            visible={visible}
            onCancel={onCancel}
            footer={null}
            width={500}
            bodyStyle={{padding: 0, background: "#fff", minHeight: 650, position: "relative"}}
            destroyOnClose
        >
            <ModalBodyWrapper>
                <SwitchLabel checked={showSelf}>
                    <Switch checked={showSelf} onChange={setShowSelf} size="small" />
                    Kendi Havuzumu Göster
                </SwitchLabel>
                <SwitchLabel checked={showUnknown} unknown>
                    <Switch checked={showUnknown} onChange={setShowUnknown} size="small" />
                    Tanımsız Havuzları Göster
                </SwitchLabel>
            </ModalBodyWrapper>
            <FilterModalContentWrapper>
                <SearchInput
                    type="text"
                    placeholder="Havuz ara..."
                    value={search}
                    onChange={e => setSearch(e.target.value)}
                />
                <ListSection>
                    <ListHeader>
                        <ListTitle color={COLORS.SUPPORTED_POOL}>Destek Alınan Havuzlar</ListTitle>
                        <Checkbox
                            checked={hiddenSupporters.length === 0}
                            indeterminate={
                                hiddenSupporters.length > 0 &&
                                hiddenSupporters.length < supporters.length
                            }
                            onChange={e =>
                                setHiddenSupporters(
                                    e.target.checked ? [] : supporters.map(s => s._id)
                                )
                            }
                            style={{fontWeight: 500, fontSize: 13, marginRight: 2}}
                        >
                            Tümünü Göster
                        </Checkbox>
                    </ListHeader>
                    <div style={{maxHeight: 180, overflowY: "auto"}}>
                        {filteredSupporters.length === 0 && (
                            <NoResultSpan>Havuz bulunamadı.</NoResultSpan>
                        )}
                        {filteredSupporters.map((supporter, idx) => {
                            const isAlsoSupporting = supportings.some(
                                supporting => supporting.pool?._id === supporter.supporterPool?._id
                            );
                            return (
                                <ListItemLabel
                                    key={supporter._id}
                                    isLast={idx === filteredSupporters.length - 1}
                                >
                                    <Checkbox
                                        checked={!hiddenSupporters.includes(supporter._id)}
                                        onChange={e => {
                                            if (e.target.checked) {
                                                setHiddenSupporters(
                                                    hiddenSupporters.filter(id => id !== supporter._id)
                                                );
                                            } else {
                                                setHiddenSupporters([
                                                    ...hiddenSupporters,
                                                    supporter._id
                                                ]);
                                            }
                                        }}
                                        style={{marginRight: 2}}
                                    />
                                    <span style={{fontWeight: 500, fontSize: 14}}>
                                        {supporter.supporterPool?.name || "-"}
                                        {isAlsoSupporting && (
                                            <span style={{color: COLORS.BOTH_SUPPORTING_AND_SUPPORTED, marginLeft: 8}}>
                                                (Hem Destek Alınan Hem Verilen)
                                            </span>
                                        )}
                                    </span>
                                </ListItemLabel>
                            );
                        })}
                    </div>
                </ListSection>
                <ListSection>
                    <ListHeader>
                        <ListTitle color={COLORS.SUPPORTING_POOL}>
                            Destek Verilen Havuzlar
                        </ListTitle>
                        <Checkbox
                            checked={hiddenSupportings.length === 0}
                            indeterminate={
                                hiddenSupportings.length > 0 &&
                                hiddenSupportings.length < supportings.length
                            }
                            onChange={e =>
                                setHiddenSupportings(
                                    e.target.checked ? [] : supportings.map(s => s._id)
                                )
                            }
                            style={{fontWeight: 500, fontSize: 13, marginRight: 2}}
                        >
                            Tümünü Göster
                        </Checkbox>
                    </ListHeader>
                    <div style={{maxHeight: 180, overflowY: "auto"}}>
                        {filteredSupportings.length === 0 && (
                            <NoResultSpan>Havuz bulunamadı.</NoResultSpan>
                        )}
                        {filteredSupportings.map((supporting, idx) => (
                            <ListItemLabel
                                key={supporting._id}
                                isLast={idx === filteredSupportings.length - 1}
                            >
                                <Checkbox
                                    checked={!hiddenSupportings.includes(supporting._id)}
                                    onChange={e => {
                                        if (e.target.checked) {
                                            setHiddenSupportings(
                                                hiddenSupportings.filter(
                                                    id => id !== supporting._id
                                                )
                                            );
                                        } else {
                                            setHiddenSupportings([
                                                ...hiddenSupportings,
                                                supporting._id
                                            ]);
                                        }
                                    }}
                                    style={{marginRight: 2}}
                                />
                                <span style={{fontWeight: 500, fontSize: 14}}>
                                    {supporting.pool?.name || "-"}
                                </span>
                            </ListItemLabel>
                        ))}
                    </div>
                </ListSection>
            </FilterModalContentWrapper>
            <FixedBottomBar>
                <ButtonWrapper>
                    <Button onClick={handleReset} style={{marginRight: 8}}>
                        Sıfırla
                    </Button>
                    <Button type="primary" onClick={handleSave}>
                        Kaydet ve Kapat
                    </Button>
                </ButtonWrapper>
            </FixedBottomBar>
        </Modal>
    );
};

export default FilterModal;
